import { ChevronRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import type { ChannelPreviewProps } from 'stream-chat-react'

import { useChatData } from 'src/features/chats/api/use-chat-data'
import ProfileAvatar from 'src/shared/features/users/components/profile-photos/profile-avatar'
import { formatMessageTime } from 'src/shared/utils/dates/format-message-time'

import { ChannelSymbol } from '../channel-symbol'

export const SidebarChannelPreview = ({ channel }: ChannelPreviewProps) => {
  const lastMessage = channel.state.messages[channel.state.messages.length - 1]

  const navigate = useNavigate()
  const result = useChatData(channel)

  if (!result || result.isLoading || !result.data || !channel.data) {
    return null
  }

  const chatData = result.data
  const hasUnreadMessages = channel.state.unreadCount > 0

  return (
    <button
      type="button"
      onClick={() => {
        if (chatData.chatPath) {
          navigate(chatData.chatPath)
        }
      }}
      className={`w-full px-4 py-3 hover:bg-accent/50 ${hasUnreadMessages ? 'bg-secondary/5' : 'bg-background'}`}
    >
      <div className="flex items-start gap-3">
        <div className="relative">
          {hasUnreadMessages && (
            <div className="absolute -left-3 top-1/2 size-1.5 -translate-y-1/2 rounded-full bg-secondary" />
          )}
          <ProfileAvatar userId={chatData.chatPartner.id} size={42} />
          {chatData.chatType && (
            <ChannelSymbol type={chatData.chatType} className="absolute -bottom-1 -right-1 size-5" />
          )}
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-0">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 truncate">
              <p className="text-base font-medium">{chatData.title}</p>
              <p>•</p>
              <p className="truncate text-muted">
                {chatData.chatType === 'partner-match' ? 'MOTW' : chatData.description}
              </p>
            </div>
            <p className="flex shrink-0 items-center gap-1 text-sm text-muted">
              {lastMessage?.created_at &&
                formatMessageTime(lastMessage.created_at as unknown as string, { short: true })}
              <ChevronRight className="size-4 text-muted" />
            </p>
          </div>
          <p className="line-clamp-1 text-start text-sm text-muted">{lastMessage?.text || 'No messages yet'}</p>
        </div>
      </div>
    </button>
  )
}
